var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { HttpClient } from "@/lib/http";
import { ENDPOINTS, OBJECTIVES_TABLES_LIST } from "./config";
export function parseDataRow(row) {
    const { objetivos, header } = row, rest = __rest(row, ["objetivos", "header"]);
    const columns = objetivos.reduce((acc, objective) => {
        OBJECTIVES_TABLES_LIST.forEach((table) => {
            if (objective[table]) {
                if (!acc[table]) {
                    acc[table] = {};
                }
                Object.assign(acc[table], objective[table]);
            }
        });
        return acc;
    }, {});
    // Use header values for the static columns instead of raw data
    return Object.assign(Object.assign(Object.assign({}, rest), header), columns);
}
export function fetchReportData(period, table) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        const rows = yield HttpClient.get(ENDPOINTS.FETCH_REPORT_DATA, {
            ano_natural: period.year,
            mes_natural: period.month,
            table: table
        });
        // Extract header keys from first row
        const headerKeys = rows.length > 0 && rows[0].header
            ? Object.keys(rows[0].header)
            : [];
        const data = rows.map(parseDataRow);
        const objectiveNames = Array.from(new Set(rows.flatMap((row) => { var _a; return ((_a = row.objetivos) !== null && _a !== void 0 ? _a : []).map((objective) => objective.name); })));
        const objectiveConfigs = ((_b = (_a = rows[0]) === null || _a === void 0 ? void 0 : _a.objetivos) !== null && _b !== void 0 ? _b : []).map((objective) => {
            var _a, _b;
            return ({
                id: String(objective.id),
                name: objective.name,
                display_name: objective.display_name,
                type: (_a = objective.type) !== null && _a !== void 0 ? _a : "",
                color: objective.color,
                activeColumns: Object.keys((_b = objective.columnas_seleccionadas) !== null && _b !== void 0 ? _b : {}),
            });
        });
        return { data, headerKeys, objectiveNames, objectiveConfigs };
    });
}
